import { render, staticRenderFns } from "./WorkIconNavWarehouseManagement.vue?vue&type=template&id=d18641b8"
import script from "./WorkIconNavWarehouseManagement.vue?vue&type=script&lang=js"
export * from "./WorkIconNavWarehouseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports